import React, {FC, ReactNode, useState} from 'react';
import {AnimatePresence, m} from 'framer-motion';

import {Button} from '@zoefin/design-system';

import {STEP_TITLES} from '../../constants';
import {useFhs, useFhsActor} from '../../store/FhsContext/hooks';

import {slideVariants, TRANSITION_DURATION, TRANSITION_EASE} from './constants';
import {DirectionType} from './types';

import styles from './styles.module.scss';

interface StepShellProps {
  children: ReactNode;
}

const StepShell: FC<StepShellProps> = ({children}) => {
  const actor = useFhsActor();
  const {stepName, stepIndex, canContinue, isFirst} = useFhs();
  const currentStep = STEP_TITLES[stepName];

  const [prevStepIndex, setPrevStepIndex] = useState(stepIndex);
  const [direction, setDirection] = useState<DirectionType>('forward');

  if (stepIndex !== prevStepIndex) {
    setDirection(stepIndex >= prevStepIndex ? 'forward' : 'back');
    setPrevStepIndex(stepIndex);
  }

  return (
    <div className={styles.stepShell}>
      <AnimatePresence mode="wait" custom={direction} initial={false}>
        <m.div
          key={stepName}
          custom={direction}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{duration: TRANSITION_DURATION, ease: TRANSITION_EASE}}
          className={styles.stepShell__slide}>
          <div>
            {currentStep?.subtitle && (
              <p className={styles.stepShell__subtitle}>
                {currentStep.subtitle}
              </p>
            )}
            <h3 className={styles.stepShell__title}>{currentStep?.title}</h3>
            {currentStep?.note && (
              <p className={styles.stepShell__note}>{currentStep.note}</p>
            )}
          </div>
          <div className={styles.stepShell__body}>{children}</div>
          {/* "Start here" CTA is only shown on the first step and has different positioning */}
          {isFirst && (
            <div className={styles.stepShell__inlineActions}>
              <Button
                as="button"
                size="large"
                disabled={!canContinue}
                onClick={() => actor.send({type: 'NEXT'})}>
                Start Here
              </Button>
            </div>
          )}
        </m.div>
      </AnimatePresence>
    </div>
  );
};

export default StepShell;
